import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CreateStoreProblem as SchemaCreateStoreProblem } from '../schemas/CreateStoreProblem';
import { type CreateStoreResponseBody as SchemaCreateStoreResponseBody } from '../schemas/CreateStoreResponseBody';
import { type DraftExternalStore as SchemaDraftExternalStore } from '../schemas/DraftExternalStore';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const CreateExternalStoreContentType = 'application/json' as const;
export type CreateExternalStoreRequest = SchemaDraftExternalStore;
export type CreateExternalStoreResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful workflow creation
     */
    '200': {
        'application/json': SchemaCreateStoreResponseBody;
    };
    /**
     * @description Bad store creation request
     */
    '400': {
        'application/json': SchemaCreateStoreProblem;
    };
    /**
     * @description Unauthorized user
     */
    '401': {
        'application/json': SchemaCreateStoreProblem;
    };
};
export type CreateExternalStoreResponseSuccess = CreateExternalStoreResponses['200']['application/json'];
export type CreateExternalStoreSearchParams = undefined;
export type CreateExternalStorePathParameters = undefined;
export const CreateExternalStoreUrl = '/stores/external' as const;
export const CreateExternalStoreMethod = 'POST' as const;
export const getCreateExternalStoreUrl = (_params?: CreateExternalStorePathParameters) => CreateExternalStoreUrl;
